<template>
  <div class="cenum-setting">
    <div class="cenue-title">User-Agent{{$t('product.shield')}}</div>
    <!--  -->
    <div class="lan-dong">
      <span class="text-gray-style">{{$t('product.Intercept')}}</span>
      <div class="checkbox-content">
        <CDNCheckbox
          @selectedCheck="selectedCheck1"
         :front="false"
         :label="$t('product.onlyWarning')"
         />

        <CDNCheckbox
          @selectedCheck="selectedCheck2"
         :front="false"
         outstyle="margin-left: 30px;"
         :label="$t('product.InterceptOnly')"
         />

        <CDNCheckbox
          @selectedCheck="selectedCheck3"
         :front="false"
         outstyle="margin-left: 30px;"
         :label="$t('product.BlackList')"
         />
      </div>
    </div>

    <!--  -->
    <div class="lan-dong">
      <span class="text-gray-style">{{$t('product.MatchType')}}
        <span class="text-gray-tip" style="margin-left: 2px;">
          {{$t('product.matchTip')}}
          </span></span>
      <div class="checkbox-content">
        <CDNCheckbox
          @selectedCheck="selectedCheck1"
         :front="false"
         :label="$t('product.FuzzyMatch')"
         />

        <CDNCheckbox
          @selectedCheck="selectedCheck2"
         :front="false"
         outstyle="margin-left: 30px;"
         :label="$t('product.PreciseMatch')"
         />
      </div>
    </div>
    <!--  -->
     <div class="lan-dong">
      <span class="text-gray-style">User-Agent</span>

       <div style="margin-top: 24px;">
         <el-input
            type="textarea"
            :rows="5"
            :placeholder="$t('product.inputTip')"
            v-model="textarea">
      </el-input>
       </div>
     </div>
    <!--  -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      textarea: '',
    };
  },
  methods: {
    selectedCheck1(e) {
      console.log(e);
    },
    selectedCheck2(e) {
      console.log(e);
    },
    selectedCheck3(e) {
      console.log(e);
    },
  },
};
</script>

<style lang="scss" scoped>
.cenum-setting {
  padding: 21px 0;
  .cenue-title {
    font-family: PingFangSC-Semibold;
    font-size: 14px;
    color: #131523;
  }
  .lan-dong {
    margin-top: 28px;
    .checkbox-content {
      margin-top: 6px;
      display: flex;
      align-items: center;
    }
  }
}
</style>
